import axios from "axios";

var counter = 0;
const win: any = window;
var token = window.location.href.includes("localhost") ? "92e7423e-5d2c-429d-aca1-9b5fff98b57b" : win["clientToken"];
var reGenerateTokenUrl = win["regenerate_url"];
var serverURL = win["base_portal_url"];
var errorPage = win["errorPageURL"];
const CEM_KEY = window.location.href.includes("localhost") ? "liCENcCCGpHUsEPHNhySYGXCnmhwzZ" : win["CEM_KEY"];

const apiBaseURL = window.location.href.includes("localhost") ? "https://apisit.mobily.com.sa/api" : win["base_api_url"];

let config = {
  api: {
    baseURL: apiBaseURL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "cem-key": CEM_KEY,
    },
  },
};

export const api = axios.create({ ...config.api });
export const simpleApi = axios.create();

api.defaults.validateStatus = function () {
  return true;
};

api.interceptors.request.use(
  async (conf: any) => {
    console.log("token : " + token);
    conf.headers.Authorization = "Bearer " + token;
    conf.headers["x-transaction-id"] = "SR_12345678";
    conf.headers["x-channel-id"] = "DAPI";
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

api.interceptors.response.use(
  async (response: any) => {
    if (
      (response.data.code && response.data.code === "APIGEE-001") ||
      (response.data.code && response.data.code === "APIGEE-002")
    ) {
      counter++;
      token = await reGenerateToken();
      const { config: oldRequest } = response;
      if (counter < 2) return api.request({ ...oldRequest });
    }

    return response;
  },
  async (error: any) => {
    if (!!errorPage) {
      document.location.href = errorPage;
    }
    return error;
  }
);

function reGenerateToken() {
  console.log("reGenerateToken :: Enter");
  console.log("reGenerateTokenUrl => " + serverURL + "" + reGenerateTokenUrl);

  return new Promise((resolve, reject) => {
    fetch(serverURL + "" + reGenerateTokenUrl, {
      method: "GET",
      headers: {
        "Content-type": "text/html; charset=UTF-8",
      },
    })
      .then((res) => res.text())

      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// get method

const coverageCheck = async ({ lon, lat }: any) => {
  return api.get(
    `${apiBaseURL}/gis-google/v1/coverage-check?lon=${lon}&lat=${lat}`
  );
};

const getPackages = async () => {
  const data = { packageType: 2, serviceType: 3 };

  return api.get(
    `${apiBaseURL}/online-sales/packages-criteria?packageType=${data.packageType}&serviceType=${data.serviceType}`
  );
};

const getEmailRecipient = async () => {
  const url =
    "digital/v1/data/mappings?contextId=CTX_LOOKUPS&catalogKey=MOBILY_EMAIL_RECIIPIENTS_LIST";
  return api.get(`${apiBaseURL}/${url}`);
};

// post method
const notifyEmail = (data: any) => {
  return api.post(`${apiBaseURL}/utility/v1/send-email`, data);
};

export { coverageCheck, getPackages, notifyEmail, getEmailRecipient };
